var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1840",
    width: 2565.8347,
    height: 780.2168,
    viewBox: "0 0 2565.8347 780.21683",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1844"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1856"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 173,-158.81152 c 0,0 1924.376,0 1924.376,0 0,0 0,-586.64649 0,-586.64649 0,0 -1924.376,0 -1924.376,0 0,0 0,586.64649 0,586.64649 z",
    id: "path1854"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1848",
    transform: "matrix(1.3333333,0,0,-1.3333333,-230.66665,991.96546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1850",
    transform: "scale(1,-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1852",
    clipPath: "url(#clipPath1856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1776.5742,-162.74023 c 0,0 88.8448,0 88.8448,0 29.4521,0 53.0107,-7.29297 72.9238,-29.73145 17.1054,-19.06934 25.8017,-44.31445 25.8017,-69.83398 0,-27.76563 -8.9746,-54.69239 -28.3261,-74.32325 -20.1953,-20.47363 -41.7901,-26.36621 -69.8379,-26.36621 0,0 -89.4063,0 -89.4063,0 0,0 0,34.98438 0,34.98438 0,0 24.7324,0 24.7324,0 0,0 0,130.27539 0,130.27539 0,0 -24.7324,0 -24.7324,0 0,0 0,34.99512 0,34.99512 z m 59.6836,-165.27051 c 0,0 25.2373,0 25.2373,0 18.5088,0 33.376,0.91699 47.1182,14.9414 12.3418,13.18164 17.3877,32.81153 17.3877,50.76368 0,16.26757 -5.3281,34.77636 -16.2666,47.39648 -13.1817,15.14551 -29.7305,17.6709 -48.8008,17.6709 0,0 -24.6758,0 -24.6758,0 0,0 0,-130.77246 0,-130.77246 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1740.6211,-197.72559 c 0,0 -27.6592,-39.83691 -27.6592,-39.83691 5.8487,-2.81934 11.3701,-6.75098 16.6699,-12.1543 12.711,-12.42578 19.4913,-29.6582 19.4913,-47.45508 0,-20.90039 -7.9092,-40.11132 -24.8614,-52.54199 -14.9697,-11.01172 -35.5898,-13.27539 -53.667,-13.27539 0,0 -77.0283,0 -77.0283,0 0,0 0,35.09961 0,35.09961 0,0 21.875,0 21.875,0 0,0 0,165.17285 0,165.17285 0,0 57.1279,0 57.1279,0 0,0 0,-35.00879 0,-35.00879 0,0 -22.0341,0 -22.0341,0 0,0 0,-33.34472 0,-33.34472 0,0 23.7822,0 23.7822,0 0,0 48.1142,68.33984 48.1142,68.33984 0,0 46.8418,0 46.8418,0 0,0 0,-34.99512 0,-34.99512 m -58.8525,-99.44629 c 0,9.32325 -3.6719,18.36133 -11.0166,24.57715 -7.624,6.49512 -16.3828,6.7793 -25.9863,6.7793 0,0 -22.8828,0 -22.8828,0 0,0 0,-62.14453 0,-62.14453 0,0 21.1894,0 21.1894,0 9.3184,0 17.793,0.2793 25.9863,6.21484 7.9082,5.36719 12.71,14.68555 12.71,24.57324 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2055.0518,-309.1377 c 0,0 34.2158,0 34.2158,0 0,0 0,-53.85156 0,-53.85156 0,0 -0.074,0 -0.074,0 0,0 0,-0.004 0,-0.004 0,0 -34.9981,0 -34.9981,0 0,0 0,5.2832 0,5.2832 -8.165,-6.60645 -18.8301,-9.48633 -29.7178,-9.48633 -32.2519,0 -60.5791,24.68164 -60.5791,57.7793 0,17.95019 7.5704,33.0957 21.878,43.75195 12.3379,9.25684 24.6806,12.90332 39.2656,17.11035 15.4238,4.48926 34.2158,9.53516 34.2158,29.44824 0,17.11036 -12.9023,27.48829 -29.4472,27.48829 -18.5147,0 -29.7315,-14.02442 -29.7315,-30.57422 0,0 -34.7812,0 -34.7812,0 0,0 0,24.58105 0,24.58105 0,0 -0.013,0 -0.013,0 0,0 0,34.99805 0,34.99805 0,0 34.998,0 34.998,0 0,0 0,-8.37695 0,-8.37695 9.0547,8.3164 20.6738,12.18847 33.7334,12.18847 36.459,0 63.3867,-26.64551 63.3867,-62.83008 0,-16.82714 -7.0146,-31.6914 -19.9131,-42.06933 -12.9043,-9.81738 -27.4882,-14.02442 -42.9121,-18.23047 -15.4287,-4.48535 -32.8174,-8.69238 -32.8174,-28.32715 0,-15.70703 12.3428,-24.96387 27.2061,-24.96387 14.8633,0 25.8027,11.22168 26.085,26.08496 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1197.626,-162.61328 c 0,0 0,-34.99805 0,-34.99805 0,0 -18.8643,0 -18.8643,0 0,0 -62.0107,-165.37793 -62.0107,-165.37793 0,0 -0.023,0.008 -0.023,0.008 0,0 0,-0.008 0,-0.008 0,0 -68.1133,0 -68.1133,0 0,0 0,34.99805 0,34.99805 0,0 16.4268,0 16.4268,0 0,0 -48.8916,130.39062 -48.8916,130.39062 0,0 -2.5361,7.1211 -2.5361,7.1211 0,0 0,27.87695 0,27.87695 0,0 25.6767,0 25.6767,0 0,0 0.01,0.003 0.01,0.003 0,0 9e-4,-0.003 9e-4,-0.003 0,0 32.7901,0 32.7901,0 0,0 0,-34.99805 0,-34.99805 0,0 -19.667,0 -19.667,0 0,0 12.3994,-33.06933 12.3994,-33.06933 0,0 65.2734,0 65.2734,0 0,0 12.3965,33.05859 12.3965,33.05859 0,0 -20.3906,0 -20.3906,0 0,0 0,34.99805 0,34.99805 0,0 33.5137,0 33.5137,0 0,0 0,0.0137 0,0.0137 0,0 0.035,-0.0137 0.035,-0.0137 0,0 41.9717,0 41.9717,0 z m -80.6543,-103.05469 c 0,0 -39.0274,0 -39.0274,0 0,0 19.5137,-52.04199 19.5137,-52.04199 0,0 19.5137,52.04199 19.5137,52.04199 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1608.0479,-162.61328 c 0,0 0,-34.99805 0,-34.99805 0,0 -14.917,0 -14.917,0 0,0 -62.0118,-165.37793 -62.0118,-165.37793 0,0 -0.022,0.008 -0.022,0.008 0,0 0,-0.008 0,-0.008 0,0 -67.7373,0 -67.7373,0 0,0 0,34.99805 0,34.99805 0,0 16.0508,0 16.0508,0 0,0 -48.8916,130.39062 -48.8916,130.39062 0,0 -25.6612,0 -25.6612,0 0,0 0,34.99805 0,34.99805 0,0 48.8018,0 48.8018,0 0,0 0.01,0.003 0.01,0.003 0,0 10e-4,-0.003 10e-4,-0.003 0,0 32.79,0 32.79,0 0,0 0,-34.99805 0,-34.99805 0,0 -19.667,0 -19.667,0 0,0 12.3994,-33.06933 12.3994,-33.06933 0,0 65.2735,0 65.2735,0 0,0 12.3965,33.05859 12.3965,33.05859 0,0 -20.3906,0 -20.3906,0 0,0 0,34.99805 0,34.99805 0,0 33.5136,0 33.5136,0 0,0 0,0.0137 0,0.0137 0,0 0.035,-0.0137 0.035,-0.0137 0,0 38.0254,0 38.0254,0 z m -76.7081,-103.05469 c 0,0 -39.0273,0 -39.0273,0 0,0 19.5137,-52.04199 19.5137,-52.04199 0,0 19.5136,52.04199 19.5136,52.04199 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1153.4541,-362.96387 c 0,0 0,34.99805 0,34.99805 0,0 20.4287,0 20.4287,0 0,0 61.9678,165.26172 61.9678,165.26172 0,0 38.585,0 38.585,0 0,0 27.7167,-73.91602 27.7167,-73.91602 0,0 27.7159,73.91602 27.7159,73.91602 0,0 38.5859,0 38.5859,0 0,0 61.9678,-165.26172 61.9678,-165.26172 0,0 25.708,0 25.708,0 0,0 0,-34.99805 0,-34.99805 0,0 -81.5986,0 -81.5986,0 0,0 0,34.99805 0,34.99805 0,0 19.6191,0 19.6191,0 0,0 -44.9893,119.98242 -44.9893,119.98242 0,0 -28.873,-77.00293 -28.873,-77.00293 0,0 16.1152,-42.97949 16.1152,-42.97949 0,0 30.8282,0 30.8282,0 0,0 0,-34.99805 0,-34.99805 0,0 -86.7188,0 -86.7188,0 0,0 0,34.99805 0,34.99805 0,0 19.6191,0 19.6191,0 0,0 -44.9892,119.98242 -44.9892,119.98242 0,0 -44.9883,-119.98242 -44.9883,-119.98242 0,0 20.3457,0 20.3457,0 0,0 0,-34.99805 0,-34.99805 0,0 -77.0459,0 -77.0459,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 215.38379,-162.66504 c 0,0 142.84961,0 142.84961,0 0,0 0,-60.58398 0,-60.58398 0,0 -34.87012,0 -34.87012,0 0,0 0,25.583 0,25.583 0,0 -51.07129,0 -51.07129,0 0,0 0,-130.27832 0,-130.27832 0,0 21.88086,0 21.88086,0 0,0 0,-34.98046 0,-34.98046 0,0 -78.78906,0 -78.78906,0 0,0 0,34.98046 0,34.98046 0,0 21.87744,0 21.87744,0 0,0 0,130.27832 0,130.27832 0,0 -21.87744,0 -21.87744,0 0,0 0,35.00098 0,35.00098 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 460.78613,-160.55762 c 57.20801,0 102.64649,-46.26172 102.64649,-103.46972 0,-55.56348 -46.25684,-101.00098 -101.82324,-101.00098 -56.9375,0 -103.19532,45.16211 -103.19532,102.64648 0,56.38575 45.98633,101.82422 102.37207,101.82422 z m 0,-37.22754 c -36.13281,0 -64.0498,-29.5625 -64.0498,-65.6914 0,-35.86133 29.01562,-64.3252 64.59668,-64.3252 35.03906,0 63.77832,29.01172 63.77832,64.04981 0,36.13281 -27.9209,65.96679 -64.3252,65.96679 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 842.18555,-362.9248 c 0,0 -78.6416,0 -78.6416,0 0,0 0,34.98046 0,34.98046 0,0 21.87793,0 21.87793,0 0,0 0,130.27832 0,130.27832 0,0 -21.87793,0 -21.87793,0 0,0 0,35.00098 0,35.00098 0,0 78.6416,0 78.6416,0 0,0 0,-35.00098 0,-35.00098 0,0 -21.76465,0 -21.76465,0 0,0 0,-130.27832 0,-130.27832 0,0 21.76465,0 21.76465,0 0,0 0,-34.98046 0,-34.98046 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 849.45996,-162.66504 c 0,0 0,-35.00098 0,-35.00098 0,0 21.87793,0 21.87793,0 0,0 0,-130.27832 0,-130.27832 0,0 -21.87793,0 -21.87793,0 0,0 0,-34.98046 0,-34.98046 0,0 114.5127,0 114.5127,0 0,0 0,34.98046 0,34.98046 0,0 -57.62793,0 -57.62793,0 0,0 0,46.2295 0,46.2295 0,0 57.6416,0 57.6416,0 0,0 0,35.00879 0,35.00879 0,0 -57.6416,0 -57.6416,0 0,0 0,49.04003 0,49.04003 0,0 64.99023,0 64.99023,0 0,0 0,-25.583 0,-25.583 0,0 34.92384,0 34.92384,0 0,0 0,60.58398 0,60.58398 0,0 -156.79884,0 -156.79884,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 272.25244,-539.61719 c 0,0 29.1919,0 29.1919,0 0,0 0,28.11377 0,28.11377 0,0 34.9873,0 34.9873,0 0,0 0,-63.1084 0,-63.1084 0,0 -163.45068,0 -163.45068,0 0,0 0,63.1084 0,63.1084 0,0 34.98877,0 34.98877,0 0,0 0,-28.11377 0,-28.11377 0,0 29.24609,0 29.24609,0 0,0 0,134.35449 0,134.35449 0,0 -21.83203,0 -21.83203,0 0,0 0,35.00977 0,35.00977 0,0 78.78906,0 78.78906,0 0,0 0,-35.00977 0,-35.00977 0,0 -21.92041,0 -21.92041,0 0,0 0,-134.35449 0,-134.35449 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 480.9043,-489.9248 c 0,0 -77.13282,0 -77.13282,0 0,0 0,-49.69239 0,-49.69239 0,0 21.59961,0 21.59961,0 0,0 0,-34.99463 0,-34.99463 0,0 -81.61816,0 -81.61816,0 0,0 0,34.99463 0,34.99463 0,0 21.87793,0 21.87793,0 0,0 0,134.35449 0,134.35449 0,0 -21.87793,0 -21.87793,0 0,0 0,35.00977 0,35.00977 0,0 81.61816,0 81.61816,0 0,0 0,-35.00977 0,-35.00977 0,0 -21.59961,0 -21.59961,0 0,0 0,-49.65332 0,-49.65332 0,0 77.13282,0 77.13282,0 0,0 0,49.65332 0,49.65332 0,0 -21.59571,0 -21.59571,0 0,0 0,35.00977 0,35.00977 0,0 81.33496,0 81.33496,0 0,0 0,-35.00977 0,-35.00977 0,0 -21.59472,0 -21.59472,0 0,0 0,-134.35449 0,-134.35449 0,0 21.59472,0 21.59472,0 0,0 0,-34.99463 0,-34.99463 0,0 -81.33496,0 -81.33496,0 0,0 0,34.99463 0,34.99463 0,0 21.59571,0 21.59571,0 0,0 0,49.69239 0,49.69239 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 547.96582,-370.25293 c 0,0 161.98047,0 161.98047,0 0,0 0,-60.58301 0,-60.58301 0,0 -35.00879,0 -35.00879,0 0,0 0,25.57324 0,25.57324 0,0 -66.95312,0 -66.95312,0 0,0 0,-49.65332 0,-49.65332 0,0 59.583,0 59.583,0 0,0 0,-35.00878 0,-35.00878 0,0 -59.583,0 -59.583,0 0,0 0,-49.69239 0,-49.69239 0,0 66.95312,0 66.95312,0 0,0 0,25.31055 0,25.31055 0,0 35.00879,0 35.00879,0 0,0 0,-60.30518 0,-60.30518 0,0 -161.98047,0 -161.98047,0 0,0 0,34.99463 0,34.99463 0,0 21.87695,0 21.87695,0 0,0 0,134.35449 0,134.35449 0,0 -21.87695,0 -21.87695,0 0,0 0,35.00977 0,35.00977 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 801.95117,-743.97412 c 0,0 0,34.99902 0,34.99902 0,0 34.99903,0 34.99903,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99903,0 -34.99903,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.6514,-743.97412 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1098.3135,-743.97412 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-743.97412 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-743.97412 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 844.28809,-743.97412 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 844.28809,-701.63672 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 844.28809,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 844.28809,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 844.28809,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 844.28809,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 844.28809,-489.94873 c 0,0 0,34.99853 0,34.99853 0,0 34.99902,0 34.99902,0 0,0 0,-34.99853 0,-34.99853 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1906"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-701.63672 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-489.94873 c 0,0 0,34.99853 0,34.99853 0,0 34.99902,0 34.99902,0 0,0 0,-34.99853 0,-34.99853 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 886.62598,-447.61133 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-701.63623 c 0,0 0,34.99853 0,34.99853 0,0 34.99902,0 34.99902,0 0,0 0,-34.99853 0,-34.99853 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-489.94873 c 0,0 0,34.99853 0,34.99853 0,0 34.99902,0 34.99902,0 0,0 0,-34.99853 0,-34.99853 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-447.61133 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 928.96387,-405.27441 c 0,0 0,35 0,35 0,0 34.99902,0 34.99902,0 0,0 0,-35 0,-35 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-489.94873 c 0,0 0,34.99853 0,34.99853 0,0 34.99902,0 34.99902,0 0,0 0,-34.99853 0,-34.99853 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-447.61133 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-405.27441 c 0,0 0,35 0,35 0,0 34.99902,0 34.99902,0 0,0 0,-35 0,-35 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-362.93652 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 971.30078,-320.59863 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-701.63623 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-489.94873 c 0,0 0,34.99853 0,34.99853 0,0 34.999,0 34.999,0 0,0 0,-34.99853 0,-34.99853 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-447.61133 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1013.6387,-405.27441 c 0,0 0,35 0,35 0,0 34.999,0 34.999,0 0,0 0,-35 0,-35 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-701.63623 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-489.94873 c 0,0 0,34.99853 0,34.99853 0,0 34.999,0 34.999,0 0,0 0,-34.99853 0,-34.99853 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1055.9756,-447.61133 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1098.3135,-701.63623 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1098.3135,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1098.3135,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1098.3135,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1098.3135,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1098.3135,-489.94873 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1225.3262,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path1998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1225.3262,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1225.3262,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.6514,-701.63623 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.6514,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.6514,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.6514,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.6514,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.6514,-489.94873 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1182.9883,-701.63623 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1182.9883,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1182.9883,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.999,0 34.999,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1182.9883,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1182.9883,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.999,0 34.999,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.999,0 -34.999,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 759.61328,-701.63623 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 759.61328,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 759.61328,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 759.61328,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 759.61328,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 801.95117,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.99903,0 34.99903,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99903,0 -34.99903,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 801.95117,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.99903,0 34.99903,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99903,0 -34.99903,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 801.95117,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.99903,0 34.99903,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99903,0 -34.99903,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 801.95117,-532.28662 c 0,0 0,34.99902 0,34.99902 0,0 34.99903,0 34.99903,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99903,0 -34.99903,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 801.95117,-489.94873 c 0,0 0,34.99902 0,34.99902 0,0 34.99903,0 34.99903,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99903,0 -34.99903,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 717.27637,-659.29883 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 717.27637,-616.96143 c 0,0 0,34.99903 0,34.99903 0,0 34.99902,0 34.99902,0 0,0 0,-34.99903 0,-34.99903 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 717.27637,-574.62402 c 0,0 0,34.99902 0,34.99902 0,0 34.99902,0 34.99902,0 0,0 0,-34.99902 0,-34.99902 0,0 -34.99902,0 -34.99902,0 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 671.94336,-162.60742 c 0,0 61.96875,-165.26563 61.96875,-165.26563 0,0 21.99707,0 21.99707,0 0,0 0,-34.99902 0,-34.99902 0,0 -44.75195,0 -44.75195,0 0,0 -0.34571,-0.12891 -0.34571,-0.12891 0,0 -0.0478,0.12891 -0.0478,0.12891 0,0 -32.74316,0 -32.74316,0 0,0 0,34.99902 0,34.99902 0,0 19.61914,0 19.61914,0 0,0 -44.99024,119.98438 -44.99024,119.98438 0,0 -44.99023,-119.98438 -44.99023,-119.98438 0,0 20.34766,0 20.34766,0 0,0 0,-34.99902 0,-34.99902 0,0 -33.47071,0 -33.47071,0 0,0 -0.0488,-0.12891 -0.0488,-0.12891 0,0 -0.34472,0.12891 -0.34472,0.12891 0,0 -46.16992,0 -46.16992,0 0,0 0,34.99902 0,34.99902 0,0 23.41504,0 23.41504,0 0,0 61.96875,165.26563 61.96875,165.26563",
    style: {
      fill: "var(--background-color)"
    },
    id: "path2052"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.3cd5ba25bf02cabf8ccd73ea5ca69486.svg";
export { ForwardRef as ReactComponent };